import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { retrieveRawInitData, useLaunchParams } from '@tma.js/sdk-react';
import { UserInfo } from '../types';
import RegistrationComponent from './registration-component';
import { api_url, production } from '@/variables';

const LandingComponent: React.FC = () => {

    const [userIsVerified, setUserIsVerified] = useState<boolean | null>(null);
    const[userInfo, setUserInfo] = useState<UserInfo | null>(null)
    
    const hash = production ? useLaunchParams().tgWebAppData?.hash : null

    // const { tgWebAppData: initData } = retrieveLaunchParams();

    // the bot can't tell if the user is a spoofed account, so we have to call
    //  out to the telegram api to verify the user\
    useEffect(() => {
        if( production ){ 
            const injectedUser = retrieveRawInitData()
            const verifyUser = async () => {
                if (injectedUser) {
                    try {
                        const response = await axios.post(`${api_url}/tg/verify`, 
                            {
                                user_str: injectedUser,
                                bot_hash: hash 
                            }
                        );
                        if (response.data) {
                            console.log('User verified successfully');
                            const decodedResponse: any = JSON.parse(
                                decodeURIComponent(injectedUser)
                                .replace("user=", "")
                                .split("&chat")[0]
                            )
                            setUserInfo({
                                telegram_id: decodedResponse.id,
                                name: decodedResponse.first_name,
                                username: decodedResponse.username,
                                email: "",
                                role: ""
                            })
                        } else {
                            console.warn('User verification failed');
                        }
                        setUserIsVerified(response.data);
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    console.log("No user was injected -- are you running in a Telegram context?")
                }
            };
            verifyUser();
        } else {
            setTimeout(() => {
                setUserIsVerified(true)
                setUserInfo({
                    telegram_id: "123456789",
                    name: "Test User",
                    username: "testuser",
                    email: "",
                    role: "staff"
                })  
            }, 2);
        }
    }, [])


    return (
        <>
            <div>
                
            </div>
            <div>
                {userIsVerified == null && 
                    <span>Verifying user...</span>
                }
                {userIsVerified == false &&
                    <span>User could not be verified. Please contact a staff member for assistance.</span>
                }
                {userIsVerified == true &&
                    <div>
                        <RegistrationComponent user={userInfo} />
                    </div>
                }
            </div>
        </>
    );
};

export default LandingComponent;